import NotificationCard from "@/components/notification/NotificationCard.vue";

export default {
    extends: NotificationCard
}